import { SelectBox } from 'src/components/SelectBox';
import { CardWithBorder } from 'src/components/CardWithBorder';
import { days, timeOptions } from './constants';
import { useContactWindow } from './ContactWindowContext';

export const WeeklyContactWindow = () => {
  const {
    selectedDays,
    toggleDay,
    startTime,
    endTime,
    setStartTime,
    setEndTime,
  } = useContactWindow();
  return (
    <CardWithBorder>
      <h3 className="mb-2">Weekly Contact Window</h3>
      <p className="text-sm text-neutral-500 mb-4">
        Define when contacts can be outreached to each week
      </p>
      <div className="flex gap-2 flex-wrap mb-4">
        {days.map((d) => {
          const active = selectedDays.includes(d.value);
          return (
            <button
              key={d.value}
              type="button"
              onClick={() => toggleDay(d.value)}
              className={`px-6 py-2 rounded-full border ${
                active
                  ? 'bg-primary/10 text-primary border-primary/20'
                  : 'bg-neutral-0 text-neutral-700 border-neutral-200'
              }`}
            >
              {d.label}
            </button>
          );
        })}
      </div>
      <div className="flex flex-col gap-2">
        <p className="text-sm text-neutral-500">Only contact between</p>
        <div className="flex items-center gap-4">
          <SelectBox
            options={timeOptions}
            value={startTime}
            onChange={(v) => {
              const option = timeOptions.find((o) => o.value === v);
              if (option) setStartTime(option);
            }}
          />
          <p className="text-sm text-neutral-500">to</p>
          <SelectBox
            options={timeOptions}
            value={endTime}
            onChange={(v) => {
              const option = timeOptions.find((o) => o.value === v);
              if (option) setEndTime(option);
            }}
          />
        </div>
      </div>
    </CardWithBorder>
  );
};

export default WeeklyContactWindow;
